module.exports = "<span data-ng-message=required>* Document Type Required</span> ";